// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import ComponentContainer from '../container-component'
import EarningsChart from '../chart-earnings'
import EarningsTable from '../table-earnings'
import { getDataChart } from '../../actions/earnings'
import Sticky from 'react-stickynode';

type Props = {
  loadEarningsData: void => void,
  earningsByDate: Object[],
  isFetching: boolean,
  error: string
}

class EarningsAnnouncementView extends Component<Props> {

  componentDidMount() {
    const {
      earningsByDate,
      loadEarningsData
    } = this.props

    if (!earningsByDate || earningsByDate.length) loadEarningsData()
  }

  render() {

    const {
      loadEarningsData,
      isFetching,
      error
    } = this.props

    return (
      <section>
        { (isFetching) ?
          (
            <ComponentContainer
              title={error || 'Loading Earnings Announcements'}
              loading={isFetching}
              empty={!!error}
              resetData={loadEarningsData}>
              <h1>loading earnings</h1>

            </ComponentContainer>

          ) : 
          (
            <section>
                <EarningsChart />
                <EarningsTable />
            </section>
          )
        }
      </section>

    )
  }
}

const mapStateToProps = (state: Object) => ({
  isFetching: state.earnings.isFetching,
  error: state.earnings.error
})

const mapDispatchToProps = (dispatch: Function) => ({
  loadEarningsData() {
    getDataChart(dispatch)
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(EarningsAnnouncementView)



// WEBPACK FOOTER //
// ./src/components/tab-earnings/index.js